import { useAccountStore } from '@/store/modules/account/store.js';

export type SmsProviderAvailability = boolean | null;

let refreshInFlight: Promise<void> | null = null;

export const useSmsProviderAvailability = () => {
    const accountStore = useAccountStore();

    const getAccount = (accountId: number | null | undefined) => {
        if (!accountId) {
            return null;
        }

        return (
            accountStore.getAccountById?.(accountId) || accountStore.accounts?.[accountId] || null
        );
    };

    const getSmsProviderAvailability = (
        accountId: number | null | undefined
    ): SmsProviderAvailability => {
        return getAccount(accountId)?.sms_provider_available ?? null;
    };

    const refreshSmsProviderAvailability = async (): Promise<void> => {
        refreshInFlight ??= accountStore.fetchAccounts(true).finally(() => {
            refreshInFlight = null;
        });

        await refreshInFlight;
    };

    const ensureSmsProviderAvailable = (
        accountId: number | null | undefined
    ): boolean | Promise<boolean> => {
        if (getSmsProviderAvailability(accountId) === true) {
            return true;
        }

        return refreshSmsProviderAvailability().then(
            () => getSmsProviderAvailability(accountId) === true
        );
    };

    return {
        getSmsProviderAvailability,
        refreshSmsProviderAvailability,
        ensureSmsProviderAvailable,
    };
};
